<div class="center-container full-size hidden" *ngIf="iframeUrl() else content">
  <iframe [src]="data.url | safeUrl" width="100%" height="100%"></iframe>
</div>
<ng-template #content>
  <div class="full-size" [innerHTML]="pageContent() | safeHTML"></div>
</ng-template>
<button class="dialog-close" appFocusRemove mat-dialog-close>
  <app-image-loading src="assets/icon_close.svg" alt="關閉" i18n-alt
                     [clickable]="true"
                     [targetWidth]="14"
                     [targetHeight]="14"/>
</button>
